"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLogger = void 0;
var immer_1 = require("immer");
var R = __importStar(require("ramda"));
var rxjs_1 = require("rxjs");
var getLogger = function (options) {
    return (0, immer_1.freeze)(new SimpleLogger(options));
};
exports.getLogger = getLogger;
var SimpleLogger = /** @class */ (function () {
    function SimpleLogger(options) {
        var _a, _b;
        this.options = options;
        this.startTime = Date.now();
        this.subject = new rxjs_1.ReplaySubject();
        this.level = (_a = options.level) !== null && _a !== void 0 ? _a : "silent";
        this.name = (_b = options.name) !== null && _b !== void 0 ? _b : "";
    }
    SimpleLogger.prototype.getMessages = function () {
        return this.subject.asObservable();
    };
    SimpleLogger.prototype.fatal = function (objOrMsg, msg) {
        this.log("fatal", objOrMsg, msg);
    };
    SimpleLogger.prototype.error = function (objOrMsg, msg) {
        this.log("error", objOrMsg, msg);
    };
    SimpleLogger.prototype.warn = function (objOrMsg, msg) {
        this.log("warn", objOrMsg, msg);
    };
    SimpleLogger.prototype.info = function (objOrMsg, msg) {
        this.log("info", objOrMsg, msg);
    };
    SimpleLogger.prototype.debug = function (objOrMsg, msg) {
        this.log("debug", objOrMsg, msg);
    };
    SimpleLogger.prototype.trace = function (objOrMsg, msg) {
        this.log("trace", objOrMsg, msg);
    };
    SimpleLogger.prototype.levelOrder = function (level) {
        switch (level) {
            case "silent": return 0;
            case "trace": return 10;
            case "debug": return 20;
            case "info": return 30;
            case "warn": return 40;
            case "error": return 50;
            case "fatal": return 60;
        }
    };
    SimpleLogger.prototype.formatDeltaTime = function (deltaMs) {
        return "".concat(deltaMs.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0, useGrouping: true }), " ms");
    };
    SimpleLogger.prototype.formatLevel = function (level) {
        switch (level) {
            case "silent": return "SILENT";
            case "trace": return "TRACE";
            case "debug": return "DEBUG";
            case "info": return "INFO";
            case "warn": return "WARN";
            case "error": return "ERROR";
            case "fatal": return "FATAL";
        }
    };
    SimpleLogger.prototype.stringify = function (obj) {
        try {
            return JSON.stringify(obj, undefined, 2);
        }
        catch (err) {
            return "<stringify error>";
        }
    };
    SimpleLogger.prototype.log = function (level, objOrMsg, msg) {
        var notShow = this.level === "silent" || this.levelOrder(level) < this.levelOrder(this.level);
        if (notShow && R.isNil(this.options.callback)) {
            return;
        }
        var deltaMs = Date.now() - this.startTime;
        var deltaStr = this.formatDeltaTime(deltaMs);
        var levelStr = this.formatLevel(level);
        var message = "".concat(levelStr, " [").concat(deltaStr, "] ").concat(this.name, " > \"").concat(typeof objOrMsg === "string" ? objOrMsg : msg, "\"");
        var obj = (typeof (objOrMsg) === "string" || R.isNil(objOrMsg)) ?
            undefined :
            this.options.formatObjects ?
                this.stringify(objOrMsg) :
                objOrMsg;
        var logMessage = (0, immer_1.freeze)({ level: level, message: message, object: typeof objOrMsg === "string" ? undefined : objOrMsg });
        if (!R.isNil(this.options.callback)) {
            this.options.callback(logMessage);
        }
        if (notShow) {
            return;
        }
        switch (level) {
            case "silent":
                throw new Error("Logger error. Silent cannot be there.");
            case "trace":
                R.isNil(obj) ? console.trace(message) : console.trace(message, obj);
                break;
            case "debug":
                R.isNil(obj) ? console.debug(message) : console.debug(message, obj);
                break;
            case "info":
                R.isNil(obj) ? console.info(message) : console.info(message, obj);
                break;
            case "warn":
                R.isNil(obj) ? console.warn(message) : console.warn(message, obj);
                break;
            case "error":
            case "fatal":
                R.isNil(obj) ? console.error(message) : console.error(message, obj);
                break;
        }
        if (this.options.storeMessages) {
            this.subject.next(logMessage);
        }
    };
    return SimpleLogger;
}());
//# sourceMappingURL=logger.js.map